import React from "react";
import FooterDefault from "../../components/shared/footers/FooterDefault";
import HeaderDefaultVerify from "../../components/shared/headers/HeaderDefaultVerify";
import BreadCrumb from "../../components/elements/BreadCrumb";
import RegisterVarifyChange from "../../components/partials/account/RegisterVarifyChange";
import NavigationList from "../../components/shared/navigation/NavigationList";

const RegisterVarifyChangePage = () => {
  const breadCrumb = [
    
    {
      text: "User Verification",
    },
  ];

  return (
    <div className="site-content">
          <HeaderDefaultVerify />
      <NavigationList />
      <div className="ps-page--my-account">
        <BreadCrumb breacrumb={breadCrumb} />
              <RegisterVarifyChange />
      </div>
      <FooterDefault />
    </div>
  );
};

export default RegisterVarifyChangePage;
